<div *ngIf="!parentdata.requireButton" class="dialog-content-min-excel" style=" text-align: center !important; ">
  
     
       <p> {{parentdata.message}}</p>
</div>

<div  *ngIf="parentdata.requireButton" style=" text-align: center !important; ">
    <div >
       <p class="lastdata"> Last data mapping synced Date: {{parentdata.requireButton}}</p>
       <p class="errormessage textalignleft"> Once you click on Sync Data Button, System will take Approx. 5 to 10 minutes to process the Syncing of the data, You can wait or do something else and come back after 5 to 10 minutes again</p>
       </div>
     <!-- <div class="card flex flex-wrap justify-center gap-4">
     <h1>Download User Mapped Data - Excel</h1>
   
       <p class="textalignleft"> {{parentdata.message}}</p>
     </div> -->
       <div class="card flex justify-center">
            <p-panel  header="" class="custompanel">
                <p class="m-0">
                    <h1>Download User Mapped Data - Excel</h1>
                    {{parentdata.message}}
              </p-panel>
        </div>
</div>


<div class="custom-dialog-footer">
     <p-button 
        *ngIf="parentdata.requireButton" class="m-1 w-full"label="Sync Data" styleClass="customesync" (click)="syncData()">
    </p-button>
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="closemodel()" ></p-button>
    <p-button class="m-1 w-full"   label="Download" styleClass="customesave" (click)="exceldatadownload()" ></p-button>
 </div>


